import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1b68fa15"),n=n(),_popScopeId(),n)
const _hoisted_1 = { style: {"position":"relative"} }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "title" }, "提示", -1))
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { class: "t1" }
const _hoisted_5 = { style: {"margin-left":"10px"} }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "t1" }
const _hoisted_8 = { style: {"margin-left":"10px"} }
const _hoisted_9 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_10 = { key: 2 }
const _hoisted_11 = { class: "t1" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "您填写的认证信息有误，请重新填写并认证。", -1))
const _hoisted_13 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_14 = { key: 3 }
const _hoisted_15 = { class: "t1" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { style: {"margin-left":"10px"} }, "您已经实名认证成功！", -1))
const _hoisted_17 = { class: "t2" }
const _hoisted_18 = { style: {"display":"flex","justify-content":"center"} }
const _hoisted_19 = {
  key: 0,
  class: "pos"
}
const _hoisted_20 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_a_row = _resolveComponent("a-row")!
  const _component_exclamation_circle_filled = _resolveComponent("exclamation-circle-filled")!
  const _component_a_button = _resolveComponent("a-button")!
  const _component_a_space = _resolveComponent("a-space")!
  const _component_a_spin = _resolveComponent("a-spin")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    title: _ctx.isShow ? null : '法大大认证',
    width: _ctx.isShow ? '40%': '80%',
    visible: _ctx.visible,
    "onUpdate:visible": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.visible) = $event)),
    footer: null,
    maskClosable: false,
    onCancel: _ctx.handleClose
  }, {
    default: _withCtx(() => [
      (_ctx.isShow)
        ? (_openBlock(), _createBlock(_component_a_row, {
            key: 0,
            justify: "center"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_a_row, { justify: "center" }, {
                  default: _withCtx(() => [
                    _hoisted_2
                  ]),
                  _: 1
                }),
                (_ctx.certStatus==0 || _ctx.certStatus==1 || _ctx.certStatus==5)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      _createVNode(_component_a_row, { class: "txtCont" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_4, [
                            _createVNode(_component_exclamation_circle_filled, { style: {"color":"#1964a6"} }),
                            _createElementVNode("span", _hoisted_5, [
                              _createTextVNode("欢迎登录苍鸾！请点击\""),
                              _createElementVNode("span", {
                                style: {"text-decoration":"underline","color":"#4475DD","cursor":"pointer"},
                                onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.handleSuce && _ctx.handleSuce(...args)))
                              }, "实名认证"),
                              _createTextVNode("\"")
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createVNode(_component_a_row, { justify: "center" }, {
                        default: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createVNode(_component_a_space, null, {
                              default: _withCtx(() => [
                                _createVNode(_component_a_button, {
                                  type: "primary",
                                  onClick: _ctx.handleSuce
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("认证")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"]),
                                _createVNode(_component_a_button, {
                                  style: {"margin-right":"10px"},
                                  onClick: _ctx.handleCtrl
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("取消")
                                  ]),
                                  _: 1
                                }, 8, ["onClick"])
                              ]),
                              _: 1
                            })
                          ])
                        ]),
                        _: 1
                      })
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.certStatus==2)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                      _createVNode(_component_a_row, { class: "txtCont" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_7, [
                            _createVNode(_component_exclamation_circle_filled, { style: {"color":"#1964a6"} }),
                            _createElementVNode("span", _hoisted_8, [
                              _createTextVNode("您现在是否要继续完成上次的认证呢，如要继续请点击“"),
                              _createElementVNode("a", {
                                onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.handleGoto('act')))
                              }, "继续认证"),
                              _createTextVNode("”。")
                            ])
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_9, [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.handleGoto('act')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("继续认证")
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.certStatus==4)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_a_row, { class: "txtCont" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_11, [
                            _createVNode(_component_exclamation_circle_filled, { style: {"color":"#1964a6"} }),
                            _hoisted_12
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_13, [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _ctx.handleSuce
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("认证")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true),
                (_ctx.certStatus==3&&_ctx.contStatus!==3)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
                      _createVNode(_component_a_row, { class: "txtCont" }, {
                        default: _withCtx(() => [
                          _createElementVNode("span", _hoisted_15, [
                            _createVNode(_component_exclamation_circle_filled, { style: {"color":"#1964a6"} }),
                            _hoisted_16
                          ]),
                          _createElementVNode("span", _hoisted_17, [
                            _createTextVNode("请先进行 \""),
                            _createElementVNode("span", {
                              style: {"text-decoration":"underline","color":"#4475DD"},
                              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleGoto('cct')))
                            }, "合同签署")
                          ])
                        ]),
                        _: 1
                      }),
                      _createElementVNode("div", _hoisted_18, [
                        _createVNode(_component_a_space, null, {
                          default: _withCtx(() => [
                            _createVNode(_component_a_button, {
                              type: "primary",
                              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.handleGoto('cct')))
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("签 署")
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_a_button, {
                              style: {"margin-right":"10px"},
                              onClick: _ctx.handleCtrl
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode("取消")
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }))
        : (_openBlock(), _createBlock(_component_a_row, { key: 1 }, {
            default: _withCtx(() => [
              (_ctx.loading)
                ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                    _createVNode(_component_a_spin)
                  ]))
                : _createCommentVNode("", true),
              _createElementVNode("iframe", {
                src: _ctx.fddurl,
                frameborder: "0",
                class: "iframe"
              }, null, 8, _hoisted_20)
            ]),
            _: 1
          }))
    ]),
    _: 1
  }, 8, ["title", "width", "visible", "onCancel"]))
}